import * as Actions from '../actions';

const initialState = {
	list: [],
	stack: null,
	logs: null,
	selected: null,
	searchText: '',
	error: null,
	os_types: [],
	images_info: [],
	acm_images: []
};

const stacksReducer = (state = initialState, action) => {
	switch (action.type) {
		case Actions.SET_OS_TYPES: {
			return {
				...state,
				error: null,
				os_types: action.payload
			};
		}
		case Actions.SET_IMAGES_INFO: {
			return {
				...state,
				error: null,
				images_info: action.payload
			};
		}
		case Actions.SET_ACM_IMAGES: {
			return {
				...state,
				error: null,
				acm_images: action.payload
			};
		}
		case Actions.SET_ACM_SHAPES: {
			return {
				...state,
				error: null,
				acm_shapes: action.payload
			};
		}
		case Actions.SET_STACKS_LIST: {
			return {
				...state,
				error: null,
				list: action.payload
			};
		}
		case Actions.SET_STACK: {
			return {
				...state,
				stack: action.payload,
				error: null
			};
		}
		case Actions.SET_LOGS: {
			return {
				...state,
				logs: action.payload
			};
		}
		case Actions.SET_SELECTED: {
			return {
				...state,
				selected: action.payload
			};
		}
		case Actions.SET_SEARCH_TEXT: {
			return {
				...state,
				searchText: action.searchText
			};
		}
		case Actions.SET_STACK_ERROR: {
			return {
				...state,
				error: action.payload
			};
		}
		case Actions.CLEAR_ERROR: {
			return {
				...state,
				error: null
			};
		}
		case Actions.CLEAR_LOGS: {
			return {
				...state,
				logs: null
			};
		}
		case Actions.CLEAR_STACK: {
			return {
				...state,
				stack: null
			};
		}
		case Actions.CLEAR_STACKS_REDUCER: {
			return initialState;
		}
		default: {
			return state;
		}
	}
};

export default stacksReducer;
